import { render, staticRenderFns } from "./FormDesgloseRenta.vue?vue&type=template&id=6a3a2630&"
import script from "./FormDesgloseRenta.vue?vue&type=script&lang=js&"
export * from "./FormDesgloseRenta.vue?vue&type=script&lang=js&"
import style0 from "./FormDesgloseRenta.vue?vue&type=style&index=0&id=6a3a2630&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports